import React from "react";
import PropTypes from "prop-types";
import { Button } from "rsuite";
import { useNavigate } from "react-router-dom";
import Table from "../common/table/Table";
import TruncatedText from "../common/TruncatedText";
import NoPromotionsIcon from "../../assets/img/no-promotions.png";
import "./PromotionsSection.scss";

const { Column, HeaderCell, Cell } = Table;

const PromotionsSection = ({
  data = [],
  loading = false,
  isPilotHotel = false,
}) => {
  const navigate = useNavigate();
  const hasData = loading || data.length > 0;
  const showEmptyState = !loading && data.length === 0;
  const entity = "Promotions";
  const entitySingular = "Promo";

  const handleManagePromotionsClick = () => {
    navigate("/promotions");
  };

  const handleCreatePromoClick = () => {
    navigate("/promotions?createPromo=true");
  };

  return (
    <section className="performance-promotions">
      <div className="performance-section-header">
        <h2>{entity}</h2>
        {hasData && (
          <Button
            className="performance-section-button"
            onClick={handleManagePromotionsClick}
          >
            Manage {entity} &gt;
          </Button>
        )}
      </div>
      <div
        className={`performance-table-container ${
          showEmptyState ? "is-empty" : "has-data"
        }`}
      >
        {showEmptyState ? (
          <div className="promotions-empty-state">
            <img
              src={NoPromotionsIcon}
              alt="no promotions"
              className="no-promotions-icon"
            />
            <Button
              appearance="primary"
              className="promotions-empty-button"
              onClick={handleCreatePromoClick}
            >
              Create {entitySingular}
            </Button>
          </div>
        ) : (
          <Table
            data={data}
            className="performance-table"
            height={400}
            loading={loading}
            hover
            headerHeight={46}
          >
            <Column flexGrow={1}>
              <HeaderCell>Promo Name</HeaderCell>
              <Cell dataKey="promoName">
                {(rowData) => <TruncatedText text={rowData.promoName} />}
              </Cell>
            </Column>
            <Column flexGrow={1}>
              <HeaderCell>Status</HeaderCell>
              <Cell dataKey="status">
                {(rowData) => (
                  <span className={`status-badge status-${rowData.statusType}`}>
                    {rowData.status}
                  </span>
                )}
              </Cell>
            </Column>
            <Column flexGrow={1}>
              <HeaderCell>Discount</HeaderCell>
              <Cell dataKey="discount" />
            </Column>
            <Column flexGrow={1}>
              <HeaderCell>Stay Dates</HeaderCell>
              <Cell dataKey="stayDates">
                {(rowData) => <TruncatedText text={rowData.stayDates} />}
              </Cell>
            </Column>
            <Column flexGrow={1}>
              <HeaderCell>Booking Window</HeaderCell>
              <Cell dataKey="bookingWindow">
                {(rowData) => <TruncatedText text={rowData.bookingWindow} />}
              </Cell>
            </Column>
            <Column flexGrow={1}>
              <HeaderCell>Created</HeaderCell>
              <Cell dataKey="created" />
            </Column>
            <Column flexGrow={1}>
              <HeaderCell>Revenue</HeaderCell>
              <Cell dataKey="revenue" />
            </Column>
          </Table>
        )}
      </div>
    </section>
  );
};

PromotionsSection.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  loading: PropTypes.bool,
  isPilotHotel: PropTypes.bool,
};

export default PromotionsSection;
